import { useQuery } from '@tanstack/react-query';
import { changeTemplateApiClient } from 'src/api/FiretrolApiClientInstances';
import { queryKeys } from 'src/api/queries/queryKeys';
import { toCancelToken } from 'src/api/queries/queryClient';

const REFERENCE_STALE_TIME = 5 * 60_000;

export function useChangeTemplates() {
  return useQuery({
    queryKey: queryKeys.organization.changeTemplates(),
    queryFn: ({ signal }) =>
      changeTemplateApiClient.index(toCancelToken(signal)),
    staleTime: REFERENCE_STALE_TIME,
    meta: {
      suppressErrorToast: true,
      errorContext: 'organization change templates',
    },
  });
}
